<template>
    <section class="page-cabinet-deals">
        <div class="page-cabinet-deals__modes">
            <div class="page-cabinet-deals__modes-item"
                 v-for="mode in modes"
                 v-bind:key="mode.code"
                 v-bind:class="{
                    _active: mode.code === activeMode,
                    _accented: mode.isAccented,
                }"
                 v-text="mode.title"
                 v-on:click="modeHandler(mode.code)"
            />
        </div>

        <div class="page-cabinet-deals__list"
            v-if="!isLoading && items && items.length > 0"
            >
            <div class="page-cabinet-deals__list-item"
                v-for="item in items"
                v-bind:key="activeMode + item.id"
                >
                <component v-bind:is="itemComponent" v-bind:item="item" />
            </div>
        </div>
        <div class="page-cabinet-deals__empty"
            v-if="!isLoading && !error && items && items.length === 0"
            v-text="'Записей не найдено'"
        />
        <div class="page-cabinet-deals__error"
            v-if="error && !isLoading"
            v-text="'Ошибка: ' + error"
        />
        <div class="page-cabinet-deals__loader"
            v-if="isLoading"
            >
            <div class="page-cabinet-deals__loader-container">
                <ui-loader />
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';
// import config from '~/config';
import utils from '~/utils';

export default {
    name: 'page-cabinet-deals',
    data: () => ({
        activeMode: 'new',
        modes: [
            { code: 'new', title: 'Первичный рынок', component: 'page-cabinet-deals-primary-item' },
            { code: 'secondary', title: 'Вторичный рынок', component: 'page-cabinet-deals-secondary-item' },
        ],
    }),
    computed: {
        ...mapState('market', [
            'getOrdersResult',
            'getOrdersError',
            'getOrdersIsLoading',

            'signOrderResult',
            'signOrderError',
            'signOrderIsLoading',

            'cancelOrderResult',
            'cancelOrderError',
            'cancelOrderIsLoading',
        ]),
        ...mapState('investments', [
            'getRequestsResult',
            'getRequestsError',
            'getRequestsIsLoading',
        ]),
        itemComponent() {
            return this.modes.find(m => m.code === this.activeMode).component;
        },
        items() {
            let result = [];
            if (this.activeMode === 'new') {
                result = this.getRequestsResult;
            } else if (this.activeMode === 'secondary') {
                result = this.getOrdersResult;
            }
            return result?.sort((a, b) => {
                if (a.status === 'wait_sign' && b.status !== 'wait_sign') return -1;
                if (a.status !== 'wait_sign' && b.status === 'wait_sign') return 1;
                return 0;
            }) || null;
        },
        isLoading() {
            return this.getOrdersIsLoading ||
                this.signOrderIsLoading ||
                this.cancelOrderIsLoading ||
                this.getRequestsIsLoading;
        },
        error() {
            if (this.activeMode === 'secondary') {
                return this.getOrdersError && utils.network.parseError(this.getOrdersError, true);
            }
            return this.getRequestsError ? utils.network.parseError(this.getRequestsError, true) : null;
        },
    },
    methods: {
        modeHandler(newMode) {
            this.activeMode = newMode;
            if (newMode === 'secondary') {
                window.location.hash = 'market';
            } else {
                window.location.hash = '';
            }
        },
        getOrders() {
            if (!this.getOrdersIsLoading) {
                this.$store.dispatch('market/getOrders', {
                    is_owner: true,
                    ordering: '-modified',
                });
            }
        },
        getItems() {
            if (this.activeMode === 'secondary') {
                this.getOrders();
            }
            if (this.activeMode === 'new') {
                this.$store.dispatch('investments/getRequests', {
                    status__in: 'new,wait_sign,signed,waiting,completed',
                    ordering: '-modified',
                });
            }
        },
    },
    mounted() {
        if (window.location.hash === '#market') {
            this.modeHandler('secondary');
        }
        this.getItems();
    },
    watch: {
        cancelOrderIsLoading(newVal, oldVal) {
            if (!newVal && this.cancelOrderResult) {
                this.getOrders();
            }
        },
        activeMode() {
            this.getItems();
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-deals {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    min-height: 100%;
    padding-bottom: 40px;

    &__modes {
        flex: 0 0 auto;
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        justify-content: flex-start;
        &-item {
            .typography-heading();

            position: relative;

            padding: 20px 0 16px;

            color: @color-gray-main;

            cursor: pointer;

            user-select: none;

            &:not(:last-child) {
                margin-right: 32px;
            }
            &._active {
                color: @color-gray-darkest;

                pointer-events: none;
            }
            &._accented {
                padding-right: 12px;
                &:before {
                    content: '';

                    position: absolute;
                    top: 20px;
                    right: 0;

                    display: block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;

                    background: @color-accent-negative;
                }
            }
        }
    }

    &__title {
        .typography-heading();

        padding: 20px 24px 16px;
    }
    &__list {
        &-item {
            &:not(:last-child) {
                margin-bottom: 8px;
            }
        }
    }
    &__empty {
        .typography-small();

        color: @color-gray-main;

        margin: auto;

        text-align: center;
    }
    &__error {
        .typography-body();

        margin: auto;

        color: @color-accent-negative;
        text-align: center;
    }
    &__loader {
        flex: 0 0 auto;
        padding: 50px;
        margin: auto;
        &-container {
            width: 50px;
        }
    }
    @media @media-md-down {
        &__empty {
            .typography-small();

            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            min-height: 100%;
            margin: auto;

            color: @color-gray-main;
        }
    }
    @media @media-sm-down {
        &__title {
            padding: 16px;
        }
    }
}
</style>
